import { Observable, defer, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Converts a boolean, a function that returns a boolean, an Observable<boolean>, or undefined into an Observable<boolean>.
 * Optionally takes a default value to use if the argument is undefined.
 * @param arg
 * @param defaultValue
 * @returns
 */
export const makeObservableBool = (
	arg: boolean | (() => boolean) | Observable<boolean> | undefined,
	defaultValue = false,
) => {
	return defer(() => {
		if (typeof arg === 'boolean' || typeof arg === 'function') {
			return of(arg);
		} else if (isObservable(arg)) {
			// Already an Observable - just return it.
			return arg;
		} else {
			return of(defaultValue);
		}
	}).pipe(
		map((valueOrFunction: boolean | (() => boolean) | undefined) => {
			if (typeof valueOrFunction === 'function') {
				return valueOrFunction();
			} else {
				return valueOrFunction ?? defaultValue;
			}
		}),
	);
};
